<template>
  <notification-base>
    <template #icon_start>
      <info-icon class="w-6 h-6 text-[var(--primary-color)]" />
    </template>
    <template #content>
      <slot name="content">
        <div class="text-th-light-gray font-light text-sm tracking-wide">
          <slot name="content_upper_row" />
        </div>
        <div>
          <slot name="content_lower_row" />
        </div>
      </slot>
    </template>
  </notification-base>
</template>

<script>
import NotificationBase from '../base'
import { InfoIcon } from '@shared/assets/icons'

export default {
  components: {
    NotificationBase,
    InfoIcon
  },
  data() {}
}
</script>
